//#region Imports
import React, { useState, useEffect } from 'react';
import { StyleSheet, SafeAreaView, useWindowDimensions, Platform } from 'react-native';
import { Card } from 'react-native-paper';
import CustomCalendar from '../../../components/CustomCalendar/CustomCalendar';
import { useTheme } from '@react-navigation/native';
import axios from 'axios';
import { useAuthContext } from '../../../hooks/useAuthContext';
import { useSignin } from '../../../hooks/useSignIn';
//#endregion

const MonthlyLeaveSchedulerScreen = (props) => {

    //#region Const Definitions
    const { colors } = useTheme()
    const { width, height } = useWindowDimensions();
    const styles = makeStyles(colors, height, width)
    const { username, user, dispatch, clientApi } = useAuthContext();
    const [data, setdata] = useState([])
    const [selectedData, setSelectedData] = useState([]);
    const {refreshSignIn} = useSignin(); 
    const [loading, setLoading] = useState(false)
    //#endregion

    // This is called from the useeffect and also from on refresh 
    const GetUpcomingLeavesCalendar = async () => {
        setLoading(true)
        await axios.get(`${clientApi}api/Employee/UpcomingLeavesFY`, {
            headers: { Authorization: `Bearer ${user.token}` },
            params: {
                Username: username
            }
        })
            .then((response) => {
                setdata(response.data)
            })
            .catch((error) => {
                // console.log(error)
                if (error.response?.status === 401) {
                    refreshSignIn(user, clientApi)
                }
            })
        setLoading(false)
    };

    //#region UseEffect
    useEffect(() => {
        setSelectedData(selectedData)
    }, [selectedData])
    useEffect(
        () => {
            // * No need to do anything here
        },
        [width, height]
    );
    useEffect(() => {
        const onUpcomingLeavesCalendar = async () => {
            await GetUpcomingLeavesCalendar()
        }
        onUpcomingLeavesCalendar()
            .catch(console.error);
    }, []);
    //#endregion

    return (
        <SafeAreaView style={styles.mainView}>
            {<Card
                style={styles.cardstyle}
                mode='elevated'>
                 <CustomCalendar
                    data={data}
                    calendarType={'SelectableDate'}
                    setSelectedData={setSelectedData}
                    isMyLeavesScreen={props.isMyLeavesScreen}
                    selectedData={selectedData}
                    setCurrDate={props.setCurrDate} />
            </Card>}
            {/* {leavesInCurrentMonthExist() &&
                    <Card style={styles.cardstyle} >
                        {data.map((leave, index) => {
                            let sDate = new Date(leave.startdate);
                            let eDate = new Date(leave.enddate);
                            // used to draw separator line below each leave except for last
                            if (index < data.length - 1) {
                                var sDateOfNextMonth = new Date(data[index + 1].startdate).getMonth() + 1;
                            };
                            if ((sDate.getMonth() + 1) == calendarDetails.month) {
                                return (
                                    <SafeAreaView
                                        key={index}>
                                        <SafeAreaView
                                            style={styles.row}>
                                            <Shape
                                                fgColor={leave.colour.toLowerCase()} // ! Colours are case sensitive in react must be all lower case 
                                                shape='CIRCLE_SMALL' />
                                            <CustomLabel
                                                value={leave.acodeDesc}
                                                type='MINOR' />
                                        </SafeAreaView>
                                        <CustomLabel
                                            value={leave.startdate === leave.enddate ? changeDateFromYYYYMMDDToDDMMYYYY(leave.startdate.substring(0, 10)) : `${changeDateFromYYYYMMDDToDDMMYYYY(leave.startdate.substring(0, 10))} - ${changeDateFromYYYYMMDDToDDMMYYYY(leave.enddate.substring(0, 10))}`}
                                            type='MINOR_extrapadding' />
                                        <CustomLabel
                                            value={leave.approved ? t('common:approved') : t('common:submitted')}
                                            type='MINOR_extrapadding' />
                                        {sDateOfNextMonth === calendarDetails.month &&
                                            <View style={styles.line} />
                                        }
                                    </SafeAreaView>
                                )
                            }
                        })}
                    </Card>
                } */}
        </SafeAreaView >
    )
};

const makeStyles = (colors, height, width) => StyleSheet.create({
    mainView: {
        flex: 1,
        alignContent: "center",
        marginTop: "1%",
    },
    row: {
        flex: 1,
        flexDirection: "row",
        justifyContent: 'space-between'
    },
    //My Leaves calendar 
    cardstyle: {
        // height: 285,
        // width: 285,
        height: Platform.OS === 'web' ? 285 : (height < 670 ? height * 45 / 100 : height * 37 / 100), 
        width: Platform.OS === 'web' ? 285 : width * 90 / 100,
        borderRadius: 10,
        elevation: 10,
    },
});

export default MonthlyLeaveSchedulerScreen;